import { toast } from 'sonner';

export function showToast({
  title,
  description,
  type = 'default',
}: {
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'info' | 'warning' | 'default';
}) {
  if (type === 'default') {
    toast(title, { description });
  } else {
    toast[type](title, { description });
  }
}
